export class Global {

}